import React, { Component } from 'react';
import { connect } from 'react-redux';
import { API_URL } from "../Constants"; // Import API_URL
import ReactGA from 'react-ga';
import trIcon from 'assets/images/cup.png';

class MyTable extends Component {

  constructor() {
    super();
    this.state = {
      data: [],
      homeTeamName: undefined,
      round: undefined,
      teams: [],
      rounds: [],

    };
    ReactGA.event({
      category: 'LiveScores',
      action: 'Open'
    });
  }

  componentDidMount() {
    fetch(`${API_URL}/app/api/v1/games?filter=status==I`)
      .then(results => {
        return results.json();
      }).then(resp => {
        const homeList = new Set(resp.map((item) => item.homeTeamName));
        const visitorList = new Set(resp.map((item) => item.visitorTeamName));
        const teamsList = new Set();
        resp.forEach(e => teamsList.add(e.homeTeamName));
        resp.forEach(e => teamsList.add(e.visitorTeamName));
        resp = resp.sort(function(a, b) {
          return b.id - a.id;
        })
        var round = [];
        if(resp && resp.length > 0){
          round = [...new Set(resp.map((item) => item.round))]
        }

        this.setState({ 
          data: resp,
          round: round.length > 0 ? round[0] : "",
          teams: [...teamsList].sort(),
          rounds: [...new Set(resp.map((item) => item.round))].sort(),
        });

        if(round.length > 0){
          this.handleSubmit(round[0] ? round[0] : "", "round")
        }
      });
  }

  handleSubmit = (variable, source) => {
    fetch(
      `${API_URL}/app/api/v1/games?filter=status==I`
    )
      .then((results) => {
        return results.json();
      })
      .then((resp) => {
        this.setState({ [source]: variable }, () => {
          const { homeTeamName, round } = this.state;
          // console.log("League: " + round + "    Team: " + homeTeamName);
          resp = resp.sort(function(a, b) {
            return b.gameNo - a.gameNo;
          })
          const filter = resp.filter((item) => {
            if(round && round !== 'Select Round' && homeTeamName && homeTeamName !== 'Select Team') {
              // console.log("Applied both filters");
              
              return (item.round === round && (item.homeTeamName === homeTeamName || item.visitorTeamName === homeTeamName));
            } else if(round && round !== 'Select Round' && (!homeTeamName || homeTeamName === 'Select Team')) {
              //apply only rounds filter
              // console.log("Applied round filters");
              return item.round === round;
            } else if(homeTeamName && homeTeamName !== 'Select Team' && (!round || round === 'Select Round')) {
              //apply only team filter
              // console.log("Applied team filter: " + homeTeamName);
              return (item.homeTeamName === homeTeamName || item.visitorTeamName === homeTeamName);
            } else {
              // console.log("Applied NO filters");
              return true;
            }            
          });
          //update state data with updated filters
          this.setState({ data: filter });
        });
      });
  };

  render() {
    return (
      <div className="card">
        <div className="header">
          <h4 className="title">Game Results</h4>
          <p className="category">Results of all concluded games</p>
          <select
            value={this.state.round}
            onChange={(e) =>
              this.handleSubmit(e.target.value, "round")
            }
          >
            <option name="0"> Select Round</option>
            {this.state.rounds.map((item) => (
              <option name={item}>{item}</option>
            ))}
          </select>
          <select
            value={this.state.homeTeamName}
            onChange={(e) => this.handleSubmit(e.target.value, "homeTeamName")}
          >
            <option name="0"> Select Team</option>
            {this.state.teams.map((item) => (
              <option name={item}>{item}</option>
            ))}
          </select>
        </div>
        <div className="content table-responsive table-full-width">
          <table className="table table-hover table-striped">
            <thead>
              <tr>
                <th className="w-90px">Game No.</th>
                <th>Home (Score)</th>
                <th>Visitor (Score)</th>
                {/* <th></th> */}
              </tr>
            </thead>
            <tbody>
              {this.state.data.map(item => (
                <tr key={item.id}>
                  <td className="w-90px">
                    <div className={`${Number(item.homeTeamScore) === Number(item.visitorTeamScore) ? "mb-4" : ""}`}>{ Number(item.homeTeamScore) === Number(item.visitorTeamScore) ? <p></p> : <h4></h4> }</div>
                    <div className={`${Number(item.homeTeamScore) !== Number(item.visitorTeamScore) ? "pt-3" : "pt-0 mt-0"}`}><h4 className={`${Number(item.homeTeamScore) !== Number(item.visitorTeamScore) ? "mt-1" : "my-0 py-0"}`}> {item.gameNo} </h4></div>
                  </td>
                  <td >
                    <div className={`${Number(item.homeTeamScore) !== Number(item.visitorTeamScore) ? "mb-2" : ""}`}>{item.homeTeamName}</div>
                    <div className={`${((!(Number(item.homeTeamScore) > Number(item.visitorTeamScore)) && Number(item.homeTeamScore) !== Number(item.visitorTeamScore)) ? "pt-4": "my-0 py-0")}`}><h4 className="my-0 py-0"> {item.homeTeamScore} {Number(item.homeTeamScore) > Number(item.visitorTeamScore) && <img width={45} className="mx-2" src={trIcon} alt="" />}</h4></div>
                  </td>
                  <td>
                    <div className={`${Number(item.homeTeamScore) !== Number(item.visitorTeamScore) ? "mb-2" : ""}`}>{item.visitorTeamName}</div>
                    <div className={`${((!(Number(item.homeTeamScore) < Number(item.visitorTeamScore)) && Number(item.homeTeamScore) !== Number(item.visitorTeamScore)) ? "pt-4": "my-0 py-0")}`}><h4 className="my-0 py-0"> {item.visitorTeamScore} {Number(item.homeTeamScore) < Number(item.visitorTeamScore) && <img width={45} className="mx-2" src={trIcon} alt="" />}</h4></div>
                  </td>
                  {/* <td>
                    {item.round}
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>

        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.Auth.user
});

export default connect(mapStateToProps)(MyTable);


// WEBPACK FOOTER //
// ./src/components/Table/GameResultsTable.js